import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_MAX_CHARS = 170;

interface ExpandableDescriptionProps {
  text: string;
  maxChars?: number;
}

export const ExpandableDescription = ({
  text,
  maxChars = DEFAULT_MAX_CHARS,
}: ExpandableDescriptionProps) => {
  const { t } = useTranslation('knowledge');

  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = text.length > maxChars;
  const displayText = isExpanded || !shouldTruncate ? text : `${text.slice(0, maxChars)}...`;

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <p className="text-sm text-foreground">
      {displayText}
      {shouldTruncate && (
        <button
          type="button"
          onClick={handleToggle}
          aria-expanded={isExpanded}
          className="ml-1 cursor-pointer font-medium text-muted-foreground hover:underline"
        >
          {isExpanded
            ? t('guidelines.expandableDescription.showLess')
            : t('guidelines.expandableDescription.showMore')}
        </button>
      )}
    </p>
  );
};

ExpandableDescription.displayName = 'ExpandableDescription';
